/* eslint-disable no-unused-vars */
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

import SubTitleContents from "reusables/TextFormats/SubTitleContents";
import ExtraServices from "reusables/sections/ExtraServices";

function Accommodation_Section5() {
  return (
    <Container>
      <ExtraServices
        description="While our regular cleaning services are thorough, there are some specialized tasks that fall outside the scope. These can be requested as add-ons for an additional fee:"
        services={[
          "Deep Carpet or Upholstery Cleaning",
          "Interior Cleaning of Appliances (e.g., ovens, refrigerators)",
          "Heavy Stain Removal",
          "Decluttering or Organizing Personal Belongings",
          "Cleaning Windows (Exterior or High Windows)",
          "Mold Removal",
          "Laundry Services for Guest Clothes",
          "Exterior Cleaning Beyond Patios or Porches",
          "Wall or Ceiling Cleaning",
          "IT Equipment Cleaning",
          "Furniture Upholstery Cleaning",
        ]}
      />
    </Container>
  );
}

export default Accommodation_Section5;
